export default __webpack_public_path__ + "static/media/logoKepler.71b4debb.png";